module.exports = __webpack_public_path__ + "img/headway-5QgIuuBxKwM-unsplash.64bd27b7.jpg";